import React from 'react';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import { App } from '@gin-betting/core';

import { NoResults } from 'components';
import globalMessages from 'messages';

type Props = WrappedComponentProps;

type State = {
    hasError: boolean;
};

class MatchErrorBoundary extends React.Component<Props, State> {
    static getDerivedStateFromError() {
        return { hasError: true };
    }

    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(error: any, errorInfo: any) {
        console.error('MatchErrorBoundary:', error, errorInfo);
    }

    handleRefresh = () => {
        if (typeof window !== 'undefined') {
            window.location.reload();
        }
    };

    render() {
        const finalMessage = this.props.intl.formatMessage(
            globalMessages.uploadError
        );

        if (this.state.hasError) {
            return (
                <NoResults
                    type={App.PageType.INNER}
                    defaultMessage={finalMessage}
                    error={this.state.hasError}
                    linkHandler={this.handleRefresh}
                />
            );
        }

        return this.props.children;
    }
}

export default injectIntl(MatchErrorBoundary);
